import { render } from "./Edit.vue?vue&type=template&id=59e44f24"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CourseRequestBookStatus/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59e44f24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59e44f24', __exports__)) {
    api.reload('59e44f24', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=59e44f24", () => {
    api.rerender('59e44f24', render)
  })

}


export default __exports__